export const everyoneGroup = "everyone";
export const credentialsAdminGroup = "credentials-admin";
